import { useEffect, useState } from "react";
import { Typography, useTheme } from "@mui/material";
import ReactFlow from "reactflow";
import "reactflow/dist/style.css";
import CustomNode from "./CustomNode";
import { useParams } from "react-router-dom";
import { useCollection } from "../../hooks/useCollection";

const nodeTypes = { customNode: CustomNode };

const Flow = () => {
  
  const { flowId } = useParams();
  const theme = useTheme();
  const [nodes, setNodes] = useState([]);
  const [flowData, setFlowData] = useState(null);
  const flowpages = useCollection("flowpage").documents;
  const flownodes = useCollection("flows").documents;


  useEffect(() => {
    if (flowId && flowpages && flownodes) {
      const flow = flowpages.find((item) => item.id === flowId);
      const flowNodes = flownodes.filter((item) => flow.nodes.includes(item.id))
      if (flowNodes) {

        const initialNodes = flowNodes.map((item) => ({
          id: item.id,
          position: item.position,
          data: {
            ...item,
            onClick: handleNodeClick,
          },
          type: item.nodeType || "default",
        }));

        setFlowData(flow);
        setNodes(initialNodes);
      }
    }
  }, [flowId, flowpages, flownodes]);

  const handleNodeClick = (url) => {
    window.open(url, "_blank");
  };

  const bgColor = `linear-gradient(to left, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`;
  return (
    <div style={{ width: "100%", height: "100vh", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: 10,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 10,
          color: "white",
          fontSize: "26px",
          fontWeight: "bold",
        }}
      >
        {flowData && <Typography fontSize={'60px'}>{flowData.title}</Typography>}
      </div>
      <ReactFlow
        nodes={nodes}
        edges={[{id:'1', source:'assyexecution', target:'edhrtemplate', style:{stroke:'#fff'}}]}
        nodeTypes={nodeTypes}
        fitView
        style={{ background: bgColor }}
      />
    </div>
  );
};

export default Flow;
